<template>
    <form @submit.prevent="$emit('submit', guest)">
        <header>
            <h3>{{ title }}</h3>
        </header>
		<!-- <p class="msg--error" v-if="error">{{ error }}</p> -->
        <custom-input :label="$t('name')" required v-model="guest.name"></custom-input>
        <p class="msg--error" v-if="error.name">{{ error.name }}</p>
        <custom-input :label="$t('email')" type="email" required v-model="guest.email"></custom-input>
        <p class="msg--error" v-if="error.email">{{ error.email }}</p>

        <custom-input :label="$t('password')" type="password" required v-model="guest.password" v-if="type === 'signup'"></custom-input>

        <AppDatePicker
            class="datepicker"
            placeholder="Select Date"
            v-model="guest.birthday"
            required
        >
            {{ 'Birthday' }}
        </AppDatePicker>

        <div class="flex-row">
            <custom-input :label="$t('weight') + '(kg)'" type="number" required min='1' v-model="guest.weight"></custom-input>
            <p class="msg--error" v-if="error.weight">{{ error.weight }}</p>
        </div>

        <custom-radio
            :label="$t('gender')"
            required
            v-model="guest.sex"
            :options="[{text: $t('male'), value: 'Male'}, {text: $t('female'), value: 'Female'}]"
        ></custom-radio>
        <p class="msg--error" v-if="error.gender">{{ error.gender }}</p>

        <div class="flex-row control">
            <button class="button--cancel" type="reset" @click.prevent="$emit('cancel')">{{ $t('cancel') }}</button>

            <button class="button--ok" type="submit">
                {{ loading ? $t('loading') : submitText }}
            </button>
        </div>
    </form>
</template>

<script>
import CustomInput from '@/components/utils/CustomInput.vue'
import CustomRadio from '@/components/utils/CustomRadio.vue'
export default {
	beforeDestroy () {
		this.$emit('close')
	},

	props: {
		error: {
			type: Object,
			default: () => {}
		},

		submitText: {
			type: String,
			default: 'Ok'
		},

		title: {
			type: String,
			default: 'Input Details'
		},

		value: {
			type: Object,
			default: () => {}
		},

		type: {
			type: String,
			default: ''
		},

		loading: {
			type: Boolean,
			default: false
		}
	},

	watch: {
		value: {
			handler (val) {
				if (!val) return
				this.guest.name = val.name || ''
				this.guest.email = val.email || ''
				this.guest.weight = val.weight || null
				this.guest.age = val.age || null
				this.guest.sex = val.sex || null
				this.guest.birthday = val.birthday || null
			},

			immediate: true
		},

		error (val) {
			if (val) {
				const el = this.$el.parentElement.parentElement
				if (el) el.scrollTo(0, 0)
			}
		}
	},

	data () {
		return {
			guest: {
				name: '',
				email: '',
				weight: null,
				age: null,
				sex: null,
				birthday: null,
				password: ''
			}
		}
	},

	components: {
		CustomInput,
		CustomRadio
	}
}
</script>

<style lang="scss" scoped>
.datepicker {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 32px;
}
</style>
